import * as Yup from 'yup'
import catchApiFailure from '../catch-api-error'
import { normalizeJsonToApi } from '../../helpers'
import configBuilder from '../config-builder'
import ApiFactory, { ApiTypes } from '../../index'
import PhoneSchema from 'schemas/PhoneSchema'
import PendingVisit from 'types/visit/pendingVisit'
const api = ApiFactory.getApi(ApiTypes.member)

export const RequestSchema = Yup.object().shape({
  memberId: Yup.string().required(),
  pendingVisitId: Yup.string().required(),
  pendingVisit: Yup.object()
    .shape({
      modality: Yup.string().required(),
      location: Yup.string().when('locationCountry', {
        is: 'US',
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired(),
      }),
      locationCountry: Yup.string().required(),
      reasonForVisit: Yup.string().required(),
      timezone: Yup.string().required(),
      phone: PhoneSchema.required(),
      scheduledAt: Yup.string(),
      providerId: Yup.string(),
      providerName: Yup.string().when('providerId', {
        is: (p?: string) => !!p,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired(),
      }),
      providerTimezone: Yup.string().when('providerId', {
        is: (p?: string) => !!p,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired(),
      }),
      visitType: Yup.string(),
      memberId: Yup.string().required(),
      memberFirstName: Yup.string().required(),
      memberLastName: Yup.string().required(),
      memberDob: Yup.string().required(),
      scheduledType: Yup.string().required(),
      createdBy: Yup.string().required(),
      createdById: Yup.string().notRequired(),
    })
    .unknown(true),
})

export type Request = Yup.InferType<typeof RequestSchema>

export const isValid = async (params: Request) => await RequestSchema.isValid(params)
export const validate = async (params: Request) => await RequestSchema.validate(params)

export const make = async (params: Request) => {
  const { pendingVisit } = RequestSchema.cast(params, { stripUnknown: true })

  return normalizeJsonToApi({
    pending_visit: pendingVisit,
  })
}

export const url = ({ memberId, pendingVisitId }: Request) => {
  return `/v1/${memberId}/visits/pending/${pendingVisitId}/reschedule`
}

export const execute = async (params: Request) =>
  // TODO: remove once configBuilder is typed
  //@ts-ignore
  api.put(url(params), await make(params), configBuilder(params)).catch(catchApiFailure)
